// frontend/src/services/analysis.service.ts

import api from './api';

const BASE_URL = '/analysis';

export class AnalysisService {

  static async listDatasets(): Promise<any[]> {
    const response = await api.get(`${BASE_URL}/datasets`);
    return response.data.data;
  }

  static async analyzeDataset(id: number): Promise<any> {
    const response = await api.get(`${BASE_URL}/dataset/${id}`);
    return response.data.data;
  }

  static async analyzeDatasetByName(datasetName: string): Promise<any> {
    const response = await api.get(`${BASE_URL}/dataset/name/${datasetName}`);
    return response.data.data;
  }

  static async analyzeDatasetByTraceId(traceId: string): Promise<any> {
    const response = await api.get(`${BASE_URL}/dataset/trace/${traceId}`);
    return response.data.data;
  }
}